import isIpad from '../isIpad';
import isMobile from '../isMobile';

var isMobileOrIpad = function isMobileOrIpad() {
  return isMobile() || isIpad();
};

export default isMobileOrIpad;